export const Option = {
    9999: {
        subject: "全部"
    }
}
